/**
 * serverIntent — thin wrapper around ServerConnection.intent() that
 * shows a toast notification on failure.
 *
 * Import this in panels/modals instead of importing ServerConnection directly.
 *
 *   import { serverIntent } from '../../core/serverIntent.js';
 *   const result = await serverIntent('trade/buy', { shipId, portId, cargoType, quantity });
 */

import { intent } from './ServerConnection.js';
import { EventBus } from './EventBus.js';

/**
 * POST /api/game/<path> with body.
 * Shows a toast on network or server error.
 * @returns {Object} response object (always has { success } field)
 */
export async function serverIntent(path, body = {}) {
  const result = await intent(path, body);
  if (!result.success) {
    EventBus.emit('ui:notification', {
      message: result.error || `Action failed: ${path}`,
      type: 'error'
    });
  }
  return result;
}
